export const spread = (obj: object) => ({
  onto: (target: { [key: string]: any }, except?: Array<string>) =>
    obj &&
    Object.keys(obj).map((k) => {
      const v = obj[k]
      if (!except || except.indexOf(k) === -1) {
        target[k] = v
      }
    })
})
